import { render, staticRenderFns } from "./GenericYConfiguration.vue?vue&type=template&id=1594668f&scoped=true&"
import script from "./GenericYConfiguration.vue?vue&type=script&lang=js&"
export * from "./GenericYConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./GenericYConfiguration.vue?vue&type=style&index=0&id=1594668f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1594668f",
  null
  
)

export default component.exports